import { useRouteContext } from '../hooks/useOutlet';
import { toRef } from 'vue';
export const useParams = () => {
    return toRef(useRouteContext(), 'params');
};
